import type { Resource } from '../../';
export const product_tiles_quickView_title: Resource = {"default":"Product Quickview"};
